'use client';
export { default } from './components/t-and-cs';
